import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faEnvelopeSquare, faArrowRight} from '@fortawesome/free-solid-svg-icons';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons';
import {Container, Row, Col, Card} from 'react-bootstrap';
import Carousel from "react-multi-carousel";
import LazyLoad from 'react-lazyload';
import "react-multi-carousel/lib/styles.css";
import '../styles/components/team.css';

const endpoint = "https://files-website-fablab.s3.amazonaws.com/team/";

const team_json = [
  { name: "Josué Venegas", picture: "josue_venegas.png", department: "TI", email: "josue.venegas@fablab.usm.cl", linkedin: "josue-venegas-almonacid" },
  { name: "Benjamin Espinoza", picture: "benjamin_espinoza.png", department: "TI", email: "benjamin.espinozahu@fablab.usm.cl", linkedin: "ben-espinoza-65388b20a" },
  { name: "Maite Mejías", picture: "maite_mejias.png", department: "TI", email: "maite.mejias@fablab.usm.cl", linkedin: "maite-alejandra-mejías-catalán-573467198"},
  { name: "Beatriz Vasquez", picture: "beatriz_vasquez.png", department: "TI", email: "beatriz.vasquez@fablab.usm.cl", linkedin: "beatriz-vasquez-cea-458020175"},
  { name: "José Tomás Dominguez", picture: "jose_dominguez.jpg", department: "Lab Manager", email: "jose.dominguez@fablab.usm.cl", linkedin: "osetomasdominguez" },
  { name: "Max Rivera", picture: "max_rivera.jpg", department: "Director", email: "max.rivera@gmail.com", linkedin: "maximiliano-rivera-4040bb5b" },
  { name: "Javier De la cerda", picture: "javier_delacerda.png", department: "Coordinación interna", email: "javier.delacerda@fablab.usm.cl", linkedin: "javier-de-la-cerda-vergara-591ab0195" },
  { name: "Octavio Jaques", picture: "octavio_jaques.png", department: "Coordinación interna", email: "octavio.jaques@fablab.usm.cl", linkedin: "octavio-jaques-2876b1197" },
  { name: "Pía Osses", picture: "pia_osses.png", department: "Vinculación con el medio", email: "pia.osses@fablab.usm.cl", linkedin: "piaossesa/" },
  { name: "Tomás Nuñez", picture: "tomas_nunez.png", department: "Coordinación interna", email: "tomas.nunez@fablab.usm.cl", linkedin: "tomás-damián-andrés-núñez-olave-8082681b8" },
  { name: "Cristóbal Martinez", picture: "cristobal_martinez.png", department: "Coordinación interna", email: "cristobal.martinez@fablab.usm.cl"},
  { name: "Eduardo Mendoza", picture: "eduardo_tapia.png", department: "Coordinación interna", email: "eduardo.tapiam@fablab.usm.cl"},
  { name: "Paulina Villalobos", picture: "paulina_villalobos.png", department: "Finanzas", email: "paulina.villalobos@fablab.usm.cl", linkedin: "paulina-villalobos-molina"},
  { name: "Nicolás Bascuñán", picture: "nicolas_bascunan.png", department: "Finanzas", email: "nicolas.bascunanp@fablab.usm.cl"},
];

const arrowStyle = {
  top: "150px",
  width: "90px",
  background: "#fcac04",
  border: "1px solid black",
  boxShadow: "0 5px 20px black"
};
  
const CustomLeft = ({ onClick }) => (
  <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left" onClick={onClick} style={arrowStyle}></button>
);

const CustomRight = ({ onClick }) => (
  <button className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right" onClick={onClick} style={arrowStyle}></button>
);



export const Team = () => {

  //Fijar paddingBottom: '30px' si se activa el renderDotsOutside y el showDots

  return ( 
    <>
    <Container fluid id="equipo" style={{background:'linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(/assets/images/Start2.png)', backgroundSize: 'cover'}} className="fablab-container">
      <Container>
        <Row>
          <Col>
          <h1 className="fablab-title white">Equipo</h1>
          </Col>
        </Row>
      </Container>

      <Carousel
        arrows = {true}  
        customLeftArrow={<CustomLeft />}
        customRightArrow={<CustomRight/>}              
        autoPlay
        autoPlaySpeed={3000}
        infinite
        centerMode
        responsive={{
            desktop: {
            breakpoint: {
                max: 3000,
                min: 1254
            },
            items: 4,
            partialVisibilityGutter: 40
            },
            tablet: {
                breakpoint: {
                    max: 1254,
                    min: 950
                },
                items: 2,
                partialVisibilityGutter: 30
                },
            mobile: {
            breakpoint: {
                max: 950,
                min: 650
            },
            items: 1,
            partialVisibilityGutter: 30
            },
            mini: {
                breakpoint: {
                    max: 650,
                    min: 0
                },
                items: 1,
                partialVisibilityGutter: 0
                }
        }}
        >

        {team_json.map((member) =>
          <Card key={member.name} className="teamCard text-center">
            <Card.Body>
                <LazyLoad height={200} offset={100}>
                  <img alt="" src={endpoint+member.picture}></img>
                </LazyLoad>
              <Card.Title className="mt-3">{member.name}</Card.Title>
              <Card.Text>
              {member.department}
              </Card.Text>
              <hr></hr>
              <a className="teamButtons mr-2" target="_blank" rel="noreferrer" href={`mailto:${member.email}`}><FontAwesomeIcon icon={faEnvelopeSquare}></FontAwesomeIcon></a>
              {member.linkedin && <a className="teamButtons" target="_blank" rel="noreferrer" href={`https://linkedin.com/in/${member.linkedin}/`}><FontAwesomeIcon icon={faLinkedin}></FontAwesomeIcon></a>}
            </Card.Body>				
          </Card>
        )}
      </Carousel>
      <Row className="mt-3">
        <Col className="text-center">
          <a className="fablab-link moving white" target="_blank" rel="noreferrer" href="/historico">Más información <FontAwesomeIcon className="fablab-button-circle white" icon={faArrowRight}/></a>
        </Col>
      </Row>
    </Container>
    </>
  );
}
